import { Component, Input, forwardRef, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-form-paragraph',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="paragraph-section">
      <div class="paragraph-header"
           [class.clickable]="isSectionHeader"
           (click)="toggleSection()">
        <div class="header-content">
          <label *ngIf="label" [attr.for]="id" class="paragraph-title">{{ label }}</label>
          <i *ngIf="isSectionHeader"
             class="fas section-arrow"
             [class.fa-chevron-down]="isExpanded"
             [class.fa-chevron-right]="!isExpanded"></i>
        </div>
        <div *ngIf="isSectionHeader && showQuestionCount" class="question-count">
          {{ completedCount }}/{{ totalCount }}
        </div>
      </div>
      <div
        *ngIf="content && content.trim()"
        [id]="id"
        [style.text-align]="textAlign"
        [style.white-space]="'pre-wrap'"
        class="paragraph-content"
        [class.section-content]="isSectionHeader"
        [class.collapsed]="isSectionHeader && !isExpanded"
      >{{ content }}</div>
    </div>
  `,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormParagraphComponent),
      multi: true
    }
  ],
  styleUrls: ['total-component.scss']
})
export class FormParagraphComponent implements ControlValueAccessor {
  @Input() label: string = ''; // 標籤
  @Input() id: string = ''; // id 用於對應 label
  @Input() name: string = ''; // name 用於表單提交
  @Input() content: string = ''; // 段落內容
  @Input() textAlign: string = 'left'; // 文字對齊方式: left, center, right
  @Input() isSectionHeader: boolean = false; // 是否為段落標題
  @Input() showQuestionCount: boolean = false; // 是否顯示問題計數
  @Input() completedCount: number = 0; // 已完成問題數
  @Input() totalCount: number = 0; // 總問題數
  @Input() isExpanded: boolean = true; // 是否展開，預設為展開

  @Output() toggleExpanded = new EventEmitter<{sectionId: string, isExpanded: boolean}>();

  value: string = ''; // 綁定的值（雖然段落元件不需要輸入，但為了相容性保留）

  onChange: (value: any) => void = () => {};
  onTouched: () => void = () => {};

  // 切換展開/收合狀態
  toggleSection(): void {
    if (this.isSectionHeader) {
      this.isExpanded = !this.isExpanded;
      this.toggleExpanded.emit({
        sectionId: this.id,
        isExpanded: this.isExpanded
      });
    }
  }

  // ControlValueAccessor 實作
  writeValue(value: any): void {
    if (value !== undefined) {
      this.value = value;
      // 如果有值傳入，可以更新 content
      if (value) {
        this.content = value;
      }
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    // 段落元件本身就是唯讀的，不需要特別處理 disabled 狀態
  }
}
